import React from 'react';
import {
  makeStyles,
  Card,
  Grid,
} from '@material-ui/core/';
import PriceList from './PriceListComponent';
import PriceInfo from './PriceInfoComponent';
import PickADate from './PickADateComponent';

const useStyles = makeStyles(() => ({
  contactDiv: {
    width: '100vw',
    padding: 15,
    zIndex: 1,
    boxShadow: '0px 1px 5px 0px black',
    overflow: 'visible',
  },
  contactForm: {
    maxWidth: '550px',
    padding: '10px',
    margin: '2%',
  },
  marBot: {
    marginBottom: '10px',
  }
}));

function PriceListPage(props) {
  const classes = useStyles();

  return (
    <Grid container >
      <Card className={classes.contactDiv}>
        <Grid container justify='space-evenly' direction='row-reverse'>
          <PriceList {...props} />
          <PriceInfo {...props} />
        </Grid>
      </Card>
      <PickADate />
    </Grid>
  );
}

export default PriceListPage;
